import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { interval } from 'rxjs/Observable/interval';

// import { map, startWith, switchMap} from "rxjs/operators";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';


@Injectable()
export class DataService {

  BASE_URL: string;
  ADMIN_BASE: string;
  NAMESPACE: string;
  // base_url: string;
  custom_token: string;
  active_app: string;
  app_logo: string;
  app_favicon: string;
  app_bg_color = '#3F3F3F';
  topics: any[];
  loading_data = false;
  messages: any;
  orders: any = {};
  stats: any;
  stats_data: any = {};
  known_languages = ["en", 'nl', 'fr', 'de'];
  SKU_id: string = 'SKU';
  user: any = {};
  login_error = false;
  current_user_name: string;
  menu_items: any; // will be filled from environment
  // pages = [
  //   {name: 'CMS', url: '/pages', resource: 'page'},
  //   {name: 'Push', url: '/messages', resource: 'message'},
  //   {name: 'Products', url: '/products', resource: 'product'},
  //   {name: 'Orders', url: '/orders', resource: 'order'},
  // ];

  images_account: string;
  images_upload_preset: string;
  upload_imagefile_url: string;
  allow_invoice_address = true;
  allow_other_free_prod = false;
  sales_db_url: any;

  constructor(private http: HttpClient, private router: Router, private sanitizer: DomSanitizer) {

    // TODO: need to get config from API server
    // NEW method use ENV for each country
    const env_keys = Object.keys(environment)
    for( const key of env_keys ){
      try{
        this[key] = environment[key]
      } catch (e) {
        console.warn(`was not able to set dataservice.${key} = ${environment[key]}`);
      }
    }

    if(!!this.sales_db_url){
      this.sales_db_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.sales_db_url);
    }
    if( !!this.ADMIN_BASE ){
      this.BASE_URL = this.ADMIN_BASE;
    }
    if( !!this.app_favicon) {
      document.getElementById('appFavicon').setAttribute('href', this.app_favicon);
    }
    if( !!this.app_bg_color) {
      document.getElementById('navbar_style').innerText = document.getElementById('navbar_style').innerText.replace(/#c3c3c3/g, this.app_bg_color);
    }

    if( !!this.images_account && !!this.images_upload_preset) {
      this.upload_imagefile_url = 'https://api.cloudinary.com/v1_1/' + this.images_account + '/image/upload?upload_preset='+ this.images_upload_preset +'&folder={folder}&public_id={filename}';
    }

    if (!!window.location
        && !!window.location.hostname
        && (window.location.hostname.startsWith('dev')
           || window.location.hostname == 'localhost'
           || document.location.host.indexOf('test') > -1)
       ) {
      console.log('DEV url detected current ns = ' + this.NAMESPACE);
      if (window.location.search == '?local'){
        this.NAMESPACE = environment['LOCAL_NAMESPACE'];
        this.BASE_URL = environment['LOCAL_BASE_URL'];
        this.active_app = this.active_app + ' (LOCALHOST)'
      } else {
        this.NAMESPACE = environment['DEV_NAMESPACE'];
        this.BASE_URL = environment['DEV_BASE_URL'];
        this.active_app = this.active_app + ' (TEST)';
      }
      console.log('new endpoint = ' + this.BASE_URL);
      console.log('new ns = ' + this.NAMESPACE);

    }



    // if (document.location.hostname.indexOf('opruimacties') > -1) {
    //   this.active_app = 'OpruimActies (SSP)';
    //   this.base_url = 'https://beta-8-0-dot-loyalty-central.appspot.com/api/SSP.DBRAMANTE__v3/';
    //   this.app_logo = 'https://shop.ssp.nl/autoimg/202553/0x0/resize/img_202553.jpg';
    //   this.images_account = 'testtube'; // TODO: get from settings
    //
    //   if (document.location.host.indexOf('test') > -1) {
    //     this.base_url = 'https://beta-8-0-dot-loyalty-central.appspot.com/api/SSP.DBRAMANTE-TST__v3/';
    //   }
    //   // if (document.location.host.indexOf(':4200') > -1) {
    //   //   this.base_url = 'http://localhost:8877/api/SSP.DBRAMANTE__v3/';
    //   // }
    //   this.menu_items = [
    //     {
    //       label: 'Dashboard',
    //       icon: 'fa-tachometer',
    //       routerLink: 'dashboard'
    //     },
    //     {
    //       label: 'Pages',
    //       icon: ' fa-file',
    //       routerLink: 'pages'
    //     },
    //     {
    //       label: 'Users',
    //       icon: ' fa-user',
    //       routerLink: 'users'
    //     },
    //     {
    //       label: 'Products',
    //       icon: 'fa-list',
    //       routerLink: 'products'
    //     },
    //     {
    //       label: 'New orders',
    //       icon: 'fa-cart-arrow-down',
    //       routerLink: 'orders/new'
    //     },
    //     {
    //       label: 'Archive',
    //       icon: ' fa-archive',
    //       routerLink: 'orders/archive'
    //     }
    //   ];
    // }




    // if (document.location.hostname.indexOf('philips-dental-pro') > -1 ||
    //     document.location.hostname.indexOf('philips-dentalcare.com') > -1 ||
    //     document.location.hostname.indexOf('dentalshop') > -1 ||
    //     document.location.hostname.indexOf('dentalshop') > -1
    // ) {
    //   this.app_logo = 'assets/imgs/philips.png';
    //
    //   this.app_bg_color = '#0073b4';
    //   this.app_favicon = 'https://philips-dentalcare.com/favicon.ico';
    //
    //   document.getElementById('appFavicon').setAttribute('href', this.app_favicon);
    //   document.getElementById('navbar_style').innerText = document.getElementById('navbar_style').innerText.replace(/#c3c3c3/g, '#0073b4')
    //
    //   this.active_app = 'Philips Dental Pro';
    //   this.base_url = 'https://philips-dental-pro.appspot.com/api/PHILIPSDENTALPRO/';
    //   this.menu_items = [
    //     {
    //       label: 'Dashboard',
    //       icon: 'fa-tachometer',
    //       routerLink: 'dashboard'
    //     },
    //     {
    //       label: 'New orders',
    //       icon: 'fa-cart-arrow-down',
    //       routerLink: 'orders/new'
    //     },
    //     {
    //       label: 'Archive',
    //       icon: ' fa-archive',
    //       routerLink: 'orders/archive'
    //     }
    //   ];
    //
    //   // if(document.location.hostname.indexOf('dentalshop-au') > -1){
    //   //   this.base_url = 'https://dentalshop-au.appspot.com/api/PHILIPSDENTALPRO/';
    //   // } else {
    //   //   if(document.location.hostname.indexOf('dentalshop-de') > -1){
    //   //     this.base_url = 'https://beta-8-2-admin-dot-dentalshop-de.appspot.com/api/PHILIPSDENTALPRO/';
    //   //     // this.base_url = 'https://dentalshop-de.appspot.com/api/PHILIPSDENTALPRO/';
    //   //     this.allow_invoice_address = false;
    //   //   } else {
    //   //     this.menu_items.push({
    //   //       label: 'Chat (support)',
    //   //       icon: ' fa-comment',
    //   //       url: 'https://dentalcare.zendesk.com/access/unauthenticated?return_to=%2Fchat%2Flogin%3Fredirect_to%3D%252Fchat%252Fagent%253F'
    //   //       });
    //   //   }
    //   // }
    //   // if (document.location.hostname.indexOf('dev') > -1){
    //   //   this.active_app = 'Philips Dental Pro (TEST)';
    //   //   this.base_url =  this.base_url.replace('https://', 'https://beta-8-3-dot-');
    //   //   this.base_url =  this.base_url.replace('PHILIPSDENTALPRO', 'PHILIPSDENTALPRO-TST');
    //   //   if(window.location.hostname.startsWith('dev_local')){
    //   //     this.base_url = 'http://localhost:8877/api/PHILIPSDENTALPRO-TST/';
    //   //   }
    //   //   if(this.base_url.indexOf('dentalshop') == -1){
    //   //     this.menu_items.push({
    //   //       label: 'Products',
    //   //       icon: 'fa-list',
    //   //       routerLink: 'products'
    //   //     })
    //   //   }
    //   // }
    //   // if (document.location.host.indexOf(':4200') > -1) {
    //   //   this.active_app = 'Philips Dental Pro (DEV)';
    //   //   this.base_url = 'http://localhost:8877/api/TST/';
    //   // }
    //   // this.custom_token = '??';
    // }
    // // if (document.location.hostname.indexOf('philips-dental-pro') > -1 || document.location.hostname.indexOf('philips-dentalcare.com') > -1) {
    // //   this.active_app = 'ViveLaFleur';
    // //   this.base_url = '/api/VLF/';
    // //   if (document.location.host.indexOf(':4200') > -1) {
    // //     this.base_url = 'http://localhost:8877/api/VLF/';
    // //   }
    // //   this.custom_token = 'Uq/HV3b5wb/XN8SMb6xxIk1GcOMndd7svOIFrDDDzOw=';
    // //   this.topics = [
    // //     {label: 'Aanbiedingen', value: { name: 'Aanbiedingen', code: 'aanbiedingen'  }},
    // //     {label: 'TEST berichten', value: { name: 'Test', code: 'test' }}
    // //   ];
    // // }

    // if (document.location.hostname.indexOf('verhage') > -1) {
    //   this.base_url = 'https://verhage-loyalty-1495026218441.appspot.com/api/VERHAGE/';
    //   this.custom_token = '5MHbfoJIR3lJkgin2/KJaaltILuqlXhK/jT0GuKeWlk=';
    //   this.active_app = 'Verhage Fast Food';
    //
    //   this.topics = [
    //     {label: 'Berkel Centrum', value: { name: 'Berkel centrum', code: 1222  }},
    //     {label: 'Gouden Hart', value: { name: 'Gouden hart', code: 1305 }},
    //     {label: 'Peppelweg', value: { name: 'Peppelweg', code: 1211 }},
    //     {label: 'Delfgauw', value: { name: 'Delfgauw', code: 1212 }}
    //   ];
    // }

    // TODO: deze zijn niet actief in gebruik (?) moeten evt nog omgezet worden naar nieuwe structuur in ENV
    // if (document.location.hostname.indexOf('portpeople') > -1) {
    //   this.active_app = 'PortPeople';
    //   this.base_url = '/api/PP/';
    //   this.app_logo = 'https://portpeople.nl/wp-content/themes/port_people_2018/images/logo-portpeople-wit.svg';
    //   if (document.location.host.indexOf(':4200') > -1) {
    //     this.base_url = 'http://localhost:8877/api/PP/';
    //   }
    //   // this.custom_token = 'Glk81KbabVjhhaUZfW+wynMRm83voaYM2v4aurIaYrQ=';
    //
    //   this.topics = [];
    //   this.http.get(this.base_url + 'topic').subscribe((items: string[]) => {
    //     for (const item of items) {
    //       this.topics.push({label: item, value: { name: item, code: item}});
    //     }
    //   });
    // }

    // if (document.location.hostname.indexOf('vive-la-fleur') > -1) {
    //   this.active_app = 'ViveLaFleur';
    //   this.base_url = '/api/VLF/';
    //   if (document.location.host.indexOf(':4200') > -1) {
    //     this.base_url = 'http://localhost:8877/api/VLF/';
    //   }
    //   this.custom_token = 'Uq/HV3b5wb/XN8SMb6xxIk1GcOMndd7svOIFrDDDzOw=';
    //   this.topics = [
    //     {label: 'Aanbiedingen', value: { name: 'Aanbiedingen', code: 'aanbiedingen'  }},
    //     {label: 'TEST berichten', value: { name: 'Test', code: 'test' }}
    //   ];
    // }
  }

  get(resource: string, map?: boolean) {
    const headers = this._getHeaders();

    // const url = this.base_url + resource;
    const url = this.BASE_URL + '/api/' + this.NAMESPACE + '/' + resource;

    return this.http.get(url, {headers: headers}).map(
      (result: any) => {
        const arr = result;
        // if (map) {
        //   arr.sort((a,b) =>{
        //     if(a['created'] > b['created'] return -1;
        //     if(a['created'] < b['created'] return 1;
        //     return 0;
        //     // let va = new Date(a['created']);
        //     // let vb = new Date(b['created']);
        //     // return  Number(vb) - Number(va);
        //   });
        // }
        return arr;
      }
    );
  }

  post(resource: string, content: any) {
    const headers = this._getHeaders();
    const url = this.BASE_URL + '/api/' + this.NAMESPACE + '/' + resource;
    const body = content;
    return this.http.post(url, body, {headers: headers});
  }

  put(resource: string, content: any) {
    const headers = this._getHeaders();
    let url = this.BASE_URL + '/api/' + this.NAMESPACE + '/' + resource;
    if(!!content['id']) {
     url += '/' + content['id'];
    }
    const body = content;
    return this.http.put(url, body, {headers: headers});
  }

  _dateFromISO8601(isostr) {
    const parts = isostr.match(/\d+/g);
    return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
  }

  _getHeaders() {
    let headers;
    if (!!this.custom_token) {
      if( !this.user ) {
        headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'x-auth': this.custom_token
        });
      } else {
        headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.custom_token
        });
      }
    } else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
    }
    return headers;
  }

  login(user: any) {
    const url = this.BASE_URL + '/api/' + this.NAMESPACE + '/' + 'admin_login';
    const headers = this._getHeaders();
    return this.http.post(url, JSON.stringify(user), {headers: headers}).map(res => {
      if (res['token']) {
        this.custom_token = res['token'];
        if(!!res['parent']) this.user = res;
        else this.user = null;
        this.current_user_name = res['name'] || res['email'];
      }
    });
  }

  logout() {
    this.custom_token = null;
    this.current_user_name = null;
    this.user = {};
    this.router.navigate(['/'])
  }

  listen_to_new_orders(period: number){
    return Observable
      .interval(period * 1000)
      .startWith(0)
      .switchMap(() => this.getOrders('new', true));
  }

  getOrders(mode: string, refresh: boolean = false) {
    if( !!this.orders[mode] ){
      if(!refresh) return Observable.of(this.orders[mode]);
    };

    this.loading_data = true;

    return this.get('order/' + mode, true).map(
      (result: any) => {
        this.loading_data = false;
        for( let order of result){
          if( order.updated_by == this.current_user_name ) order.is_mine = true;
          order.as_text = JSON.stringify(order);
          // correct total if needed
          let tot = 0;
          for(const item of order.items){
            tot += item.sub_total;
          }
          order.total_price = tot;
          if( !!order.parent && !order.parent.ext_id ) {
            if( !!order.parent.status && order.status == 'NEW'){
              order.status = order.parent.status;
            } else {
              //order.status = '???';
            }
          }
        }
        result.sort((a,b) =>{
            if(a['created'] > b['created']) return -1;
            if(a['created'] < b['created']) return 1;
            return 0;
        });
        this.orders[mode] = result;
        return this.orders[mode];
      },
      (err) => {
        this.loading_data = false;
        console.log(err);
      }
    );
  }


  upload_imagefile_for_product(prod: any, file: any) {
    const folder = this.active_app;
    const filename = prod.id + '_' + Math.floor(Math.random() * 100000000);

    const post_url = this.upload_imagefile_url.replace('{folder}', folder).replace('{filename}', filename);

    const formData: FormData = new FormData();
    // formData.append('upload_preset', env.CLOUDINARY_UPLOAD_PRESET);
    formData.append('file', file);
    // let headers = new Headers();
    // headers.append('X-Requested-With', 'XMLHttpRequest');
    return this.http.post(post_url, formData);
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/providers/data.service.ts